import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperDocTab: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "24px",
    },
  };
});
